import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import type { CharacterPageRowType, CharacterPropsType } from '../../models/Character'
import { FadeInImage } from '@components/shared/FadeInImage'
import HorizontalMediumTrackRow from '@components/Discover/HorizontalMediumTrackRow'
import HorizontalMediumBookRow from '@components/Discover/HorizontalMediumBookRow'

export function CharacterDetail (props: CharacterPropsType): React.ReactNode {
  return (
    <CharacterDetailContainer>
      <TitleContainer>
        <CharacterImageContainer>
          <FadeInImage src={props.imageUrl} width={500} height={250}/>
        </CharacterImageContainer>
        <DescriptionContainer>{props.description}</DescriptionContainer>
      </TitleContainer>
      {props.pageRows.map((rec: CharacterPageRowType, index: number): React.ReactNode => {
        return (
            <SectionDivider key={`hunk-page-${props.id}-row-${index}`}>
              {rec.displayType === 'horizontalMediumTrackRow' && <HorizontalMediumTrackRow {...rec}/> }
              {rec.displayType === 'horizontalMediumBookRow' && <HorizontalMediumBookRow {...rec}/> }
            </SectionDivider>
        )
      }
      )}
    </CharacterDetailContainer>
  )
}

const DescriptionContainer = styled.div<any>`
  font-family: "Good Sans Regular";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 126.667% */
  letter-spacing: -0.3px;
  color: ${colors.white};
  width: 80%;
  text-align: center;
  margin-top: 26px;
  ${(props: any): any => config(props).media.xs`
  `}
  ${(props: any): any => config(props).media.sm`
  `}
  ${(props: any): any => config(props).media.md`
        font-size: 16px;
  `}
  ${(props: any): any => config(props).media.lg`
  `}
  ${(props: any): any => config(props).media.xl`
  `}
`
const CharacterImageContainer = styled.div<any>`
    width: 200px;
    height: 100px;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
      width: 200px;
      height: 100px;
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`

const TitleContainer = styled.div<any>`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    border-bottom: 0.5px solid ${colors.white};
    padding-bottom: 26px;
    padding-top: 26px;
    ${(props: any): any => config(props).media.md`
      padding-top: 36px;
      padding-bottom: 36px;
    `}
`
const CharacterDetailContainer = styled.div<any>`
    display: flex;
    width: 100%;
    flex-direction: column;
`

const SectionDivider = styled.div<any>`
    margin-top: 26px;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
      margin-top: 36px;
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`
